import { FC } from 'react'
import { Button2 } from '@/componentsV2/atoms/Button2'
import { sanitizeUrl } from '@/utils'
import styles from './index.module.scss'

export const SubsidyInquiryGroup: FC = () => {
  return (
    <div className={styles.container}>
      <div className='container'>
        <div className={styles.content}>
          <div className={styles.header}>
            <h2 className={styles.title}>補助金・助成金に関するご相談</h2>
            <p className={styles.subText}>
              スタートアップの資金調達手段の一つとして補助金・助成金の申請支援を行っています。
              気になることがございましたら、お気軽にこちらからご相談ください。
            </p>
          </div>
          <div className={styles.btn}>
            <Button2
              componentType='a'
              anchorTarget='_blank'
              href={sanitizeUrl(process.env.NEXT_PUBLIC_CONTACT_SUBSIDY_JA_URL)}
              size='xl'
            >
              お問い合わせ
            </Button2>
          </div>
        </div>
      </div>
    </div>
  )
}
